import type { CardRankingProps } from "./CardRanking.types";
import type { LeaderboardClusterData } from "../../queries/leaderboard.types";
import type { LeaderboardItem, LeaderboardResponse } from "../../types";

export const CardRankingDefault: CardRankingProps = {
  isUserPage:false
};

export const CardRankingClusters: LeaderboardClusterData[] = [
  {
    anonymize: false,
    corporate_id: 1,
    id: 1,
    initiative_id: 1,
    is_visible: true,
    name: "Classifica generale"
  },
  {
    anonymize: false,
    corporate_id: 1,
    id: 2,
    initiative_id: 1,
    is_visible: true,
    name: "Classifica di team"
  }
];

const students: LeaderboardItem[] = [
  { name: "Giulia Rossi", score: 1250, trend: "UP" },
  { name: "Marco Bianchi", score: 1180, trend: "EQUALS" },
  { name: "Sara Verdi", score: 1095, trend: "DOWN" },
  { name: "Luca Neri", score: 980, trend: "UP" },
  { name: "Anna Gallo", score: 870, trend: "DOWN" },
  { name: "Paolo Costa", score: 760, trend: "EQUALS" }
].map(({ name, score, trend }, idx) => ({
  corporateId: 1,
  domainId: 1,
  isCaller: idx === 2,
  profilePic: "",
  ranking: idx + 1,
  studentEid: `student-${idx + 1}`,
  studentName: name,
  totalScore: score,
  trend: trend as LeaderboardItem["trend"]
}));

export const CardRankingLeaderboard: LeaderboardResponse = {
  callerRanking: students[2],
  leaderboards: students,
  metadata: {
    topic_ids: [],
    totalElements: students.length,
    totalPages: 1
  }
};
